import { getInfo, NameAndLabelFormatter } from '@Components/Grid/components/Table/formatters';
import { formatDate } from '@Utils/index';

export default function DescriptionFormatter({ info }) {
  const { value, row } = getInfo(info)

  return <>
    <NameAndLabelFormatter
      title={value}
      subtitle={`Created at: ${formatDate(row.created_at, 'MMM DD, YYYY - hh:mm A')} by ${row.user ? `${row.user.first_name} ${row.user.last_name}` : '--' }`} />
  </>
}
